import { Observable } from 'rxjs';

import { UserMood } from 'user/mood/user-mood';

export abstract class UserMoodRepositoryPort {
	public abstract observeLatestUserMood(): Observable<UserMood>;

	public abstract persistUserMoods(entities: UserMood[]): void;

	public abstract observeUserMoodsByIds(
		moodsId: string[]
	): Observable<UserMood[]>;
}
